import { ExtensionNotice } from "../../../../customNotice/clientNotice/extensionNotice";
import { AddressCheckNotice, AddressCheckAddress } from "../../../../customNotice/botNotice/addressCheckNotice";
import { ConfigurationManager } from "../../../../utils/configurationManager";
export class AddressCheckExtension {
    constructor(chatScreen) {
        this.name = 'addressCheck';
        this.NO_ADDRESS = "Keine Eingabe";
        this.SEND_ADDRESS = "Adresse gesendet";
        this.BASE_PATH = "https://www.a1.net/kara/gucci/";
        this.JS = "microfrontend-lkms/index.js";
        this.ASSET_BASE_PATH = "https://cdn11.a1.net/assetsup/free/genesys-chatui/last/";
        this.CSS = "widgetResources/css/addressCheck.css";
        this.API = "microfrontend-lkms/api";
        this.SOURCE_SYSTEM = "Chatbot";
        this.USER = "UCHATBOT1";
        this.isLoaded = false;
        this.chatScreen = chatScreen;
        this.addressCheck = $('<div></div>');
        this.addressCheck.addClass("cbot-js-content-space");
        this.addressCheck.addClass("cbot-address-check");
        chatScreen.elements['completeChatwindow'].append(this.addressCheck);
        let configuration = this.chatScreen.uic.configuration;
        this.NO_ADDRESS = ConfigurationManager.setValueIfExists(configuration, 'i18n.addressCheckNoAddress', this.NO_ADDRESS);
        this.SEND_ADDRESS = ConfigurationManager.setValueIfExists(configuration, 'i18n.addressCheckSendAddress', this.SEND_ADDRESS);
        this.BASE_PATH = ConfigurationManager.setValueIfExists(configuration, 'endpoints.gucci', this.BASE_PATH);
        this.ASSET_BASE_PATH = ConfigurationManager.setValueIfExists(configuration, 'assetBase', this.ASSET_BASE_PATH);
        this.JS = ConfigurationManager.setValueIfExists(configuration, 'addressCheckSettings.js', this.JS);
        this.CSS = ConfigurationManager.setValueIfExists(configuration, 'addressCheckSettings.css', this.CSS);
        this.API = ConfigurationManager.setValueIfExists(configuration, 'addressCheckSettings.api', this.API);
        this.USER = ConfigurationManager.setValueIfExists(configuration, 'addressCheckSettings.user', this.USER);
        this.SOURCE_SYSTEM = ConfigurationManager.setValueIfExists(configuration, 'addressCheckSettings.sourceSystem', this.SOURCE_SYSTEM);
        this.addressCheck.hide();
    }
    activate(options) {
        this.chatScreen.loadingAnimation();
        this.loadWidget();
    }
    deactivate() {
        this.chatScreen.uic.widget.getStateMachine().setScreenProperty("chat", "showAddressCheck", false);
        this.chatScreen.stopLoadingAnimation();
        this.addressCheck.hide();
        this.chatScreen.showMainInput();
        this.chatScreen.resizeEvent();
    }
    resize() {
    }
    loadWidget() {
        if (!this.isLoaded) {
            try {
                this.loadCss();
                const scriptElem = document.createElement('script');
                scriptElem.src = this.BASE_PATH + this.JS;
                scriptElem.addEventListener('load', () => {
                    var portalAppSetup = {
                        appConfig: {
                            sourceSystem: this.SOURCE_SYSTEM,
                            user: this.USER,
                            showDetailButton: false,
                            showCancelButton: false,
                            smallText: true,
                            hideLKMSId: true,
                            searchOnlyMainAddresses: false,
                            returnMessageAddressDetails: true,
                            allowSearchbyVillage: false,
                            enableSearches: "ADDRESS",
                            showHeader: false,
                        },
                        lang: "de",
                        restProxyPaths: {
                            bff: this.BASE_PATH + this.API
                        }
                    };
                    var clientServices = {
                        messageBus: {
                            subscribe: function (topic, handler) {
                            },
                            unsubscribe: function (topic, handler) {
                            },
                            publish: (topic, data) => {
                                if (topic === 'lkms-search-result-details') {
                                    this.confirmAddress(data);
                                }
                            }
                        }
                    };
                    try {
                        window.startupAddressSearch(this.addressCheck.get(0), portalAppSetup, clientServices);
                        this.show();
                    }
                    catch (e) {
                        this.showErrorMessage();
                    }
                });
                scriptElem.addEventListener("error", () => {
                    this.showErrorMessage();
                });
                this.observeChange();
                document.head.appendChild(scriptElem);
                this.isLoaded = true;
            }
            catch (e) {
                this.showErrorMessage();
            }
        }
        else {
            this.show();
        }
    }
    showErrorMessage() {
        this.chatScreen.uic.widget.sendCustomNotice(new ExtensionNotice(this.name, this.chatScreen.uic.widget.getWidgetApplicationId(), false, null));
        this.chatScreen.uic.widget.showUserMessage(this.NO_ADDRESS);
        this.chatScreen.uic.widget.sendCustomNotice(new AddressCheckNotice(false, true, new AddressCheckAddress()));
        this.deactivate();
    }
    closeExtension() {
        this.chatScreen.uic.widget.sendCustomNotice(new ExtensionNotice(this.name, this.chatScreen.uic.widget.getWidgetApplicationId(), false, null));
        this.chatScreen.uic.widget.showUserMessage(this.NO_ADDRESS);
        this.chatScreen.uic.widget.sendCustomNotice(new AddressCheckNotice(true, false, new AddressCheckAddress()));
        this.deactivate();
    }
    show() {
        this.chatScreen.stopLoadingAnimation();
        this.chatScreen.hideMainInput();
        this.addressCheck.show();
        this.chatScreen.resizeEvent();
    }
    observeChange() {
        const targetNode = this.addressCheck.get(0);
        const config = { childList: true };
        const callback = (mutationsList, observer) => {
            $('.cbot-address-check .gucci-common-button:last-of-type button').text("Senden");
            this.addCloseButton();
            observer.disconnect();
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
    confirmAddress(addressData) {
        this.chatScreen.uic.widget.sendCustomNotice(new ExtensionNotice(this.name, this.chatScreen.uic.widget.getWidgetApplicationId(), false, null));
        let address = this.createAddressDetailsFromData(addressData);
        this.chatScreen.uic.widget.showUserMessage(this.getAddressString(addressData));
        this.chatScreen.uic.widget.sendCustomNotice(new AddressCheckNotice(false, false, address));
        this.deactivate();
    }
    getAddressString(addressData) {
        if (addressData.AddressLine1 && addressData.AddressLine2) {
            return addressData.AddressLine1 + "<br>" + addressData.AddressLine2;
        }
        else {
            return this.SEND_ADDRESS;
        }
    }
    createAddressDetailsFromData(addressData) {
        let address = new AddressCheckAddress();
        address.street = addressData.Street ? addressData.Street : '';
        address.zipCode = addressData.Postcode ? addressData.Postcode : '';
        address.houseDescription = addressData.HouseNumber ? addressData.HouseNumber : '';
        address.houseDescription += addressData.Staircase ? '/' + addressData.Staircase : '';
        address.doorNumber = addressData.FloorNumber ? addressData.FloorNumber : '';
        if (address.doorNumber && addressData.DoorNumber) {
            address.doorNumber += '/';
        }
        address.doorNumber += addressData.DoorNumber ? addressData.DoorNumber : '';
        address.id = addressData.LkmsId;
        return address;
    }
    addCloseButton() {
        const a = document.createElement('a');
        a.href = 'javascript:void(0)';
        a.classList.add("cbot-chatWindow__link");
        a.title = "Adresseingabe schließen";
        a.id = "cbot-address-check-close";
        a.addEventListener("click", () => {
            this.closeExtension();
        });
        const i = document.createElement('i');
        i.ariaHidden = true;
        i.classList.add("cbot-icon-close");
        i.classList.add("cbot-chatWindow__icon");
        a.appendChild(i);
        this.addressCheck.get(0).appendChild(a);
    }
    loadCss() {
        var fileref = document.createElement("link");
        fileref.rel = "stylesheet";
        fileref.type = "text/css";
        fileref.href = this.ASSET_BASE_PATH + this.CSS;
        document.getElementsByTagName("head")[0].appendChild(fileref);
    }
}
/*
AddressData Example

Additional: undefined
AddressLine1: "Schwedenplatz 3-4/1/4/13"
AddressLine2: "1010 Wien"
AddressLine3: ""
Authority: "1"
Block: undefined
City: "Wien"
DoorNumber: "13"
FloorNumber: "4"
HouseNumber: "3-4"
HouseNumberPrefix: undefined
LkmsId: "13986296"
MeasurementMethod: "3"
Municipal: "Wien-Innere Stadt"
ParentLkmsId: "281067"
Postcode: "1010"
ReferenceTo: "2"
Staircase: "1"
Street: "Schwedenplatz"
Village: "Wien"
XWorld: "48.211183"
YWorld: "16.378714"
*/
